export default "__VITE_ASSET__BkW3ahnN__"